export const CONTRACTS_LOAD_REQUEST = 'CONTRACTS_LOAD_REQUEST';
export const CONTRACTS_LOAD_SUCCESS = 'CONTRACTS_LOAD_SUCCESS';
export const CONTRACTS_LOAD_FAILURE = 'CONTRACTS_LOAD_FAILURE';
